import { module } from 'modujs';
import { Swiper, Navigation } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        Swiper.use([Navigation]);
        this.container = this.$('container')[0];
        this.arrowNext = this.$('next')[0]
        this.arrowPrev = this.$('prev')[0]

        this.carousel = new Swiper(this.container, {
            speed: 900,
            spaceBetween: 0,
            grabCursor: true,
            slidesPerView: 1.15,
            spaceBetween: 0,
            threshold: 3,
            navigation: {
                prevEl: this.arrowPrev,
                nextEl: this.arrowNext
            },
            breakpoints: {
                700: {
                    slidesPerView: 2,
                    loopedSlides: 3,
                }
            }
        });
    }

    destroy() {
        if(this.carousel && this.carousel.destroy) this.carousel.destroy()
    }
}
